<template>
  <div class="addr_list room__block">
    <div class="addr_list__panel">
      <h3>{{ $t('message.address.list.title') }}</h3>
      <p>{{ $t('message.address.subtitle') }}</p>
      <div class="addr_list__list">
        <template v-if="addrList.length >0">
          <div class="addr_list__item global_pointer" v-for="item in addrList" :key="item.id" @click="selectAddr(item)">
            <div class="addr_list__info">
              <div class="base">
                <span class="default" v-if="item.defaultAddr == 1">{{ $t('message.address.list.default') }}</span>
                <span class="name">{{item.lastName + item.firstName}}</span>
                <div class="mobile">{{item.mobile}}</div>
              </div>
              <div class="address">{{item.address + ' ' + item.city + ' ' + item.province + ' '+ item.postCode +' ' + item.country}}</div>
            </div>
            <img class="addr_list__edit global_pointer" src="@/assets/imgs/address/icon-edit.png" alt="" @click.stop="editAddr(item.id)">
          </div>
        </template>
        <div v-else class="addr_list__empty">
          <img :src="require('@/assets/imgs/address/default.png')" >
          <span>{{ $t('message.address.empty') }}</span>
        </div>
      </div>
      <div class="addr_list__bottom">
        <div class="addr_list__add_button global_pointer" @click="newAddr">{{ $t('message.address.list.add') }}</div>
      </div>
      <img class="pay_list__close global_pointer" src="@/assets/imgs/close.png" alt="close" @click="close">
    </div>
  </div>
</template>
<script>
import api from "@/api/api_list.js";
export default {
  name: 'addressList',
  data(){
    return {
      addrList: []
    }
  },
  created(){
    api.get_addr_list()
    .then(res=>{
      console.log(res)
      this.addrList = res.result
    })
  },
  methods:{
    newAddr(){
      this.$emit('newAddr')
    },
    editAddr(id){
      this.$emit('editAddr',id)
    },
    selectAddr(addr){
      
      let addrArr = [addr.address ,addr.district, addr.city, addr.province, addr.postCode, addr.country].filter(Boolean)
      this.$emit('selectAddr',addr.id,addrArr.join(' '))
    },
    close(){
      this.$emit('close')
    }
  }
}
</script>
<style lang="less">
.addr_list {
  background: rgba(0, 0, 0, 0.5);
  &__panel {
    position: absolute;
    z-index: 100;
    width: 100%;
    background: #ffffff;
    left: 0;
    bottom: 0;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    overflow: hidden;
    padding: 50px 32px 0;
    box-sizing: border-box;
    text-align: left;
    color: #231F20;
    & h3{
      height: 40px;
      font-size: 24px;
      font-weight: bold;
      color: #231F20;
      line-height: 40px;
      margin: 0;
      padding: 0;
      text-align: left;
      font-weight: 600;
    }
    > p {
      height: 20px;
      line-height: 20px;
      font-size: 14px;
      font-weight: 600;
      margin-bottom: 24px;
    }
  }
  &__list{
    height: 350px;
    overflow-y: auto;;
    padding-bottom: 110px;
  }
  &__item{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 0;
    border-bottom: 1px solid #E8E8E8;
  }
  &__info{
    width: 243px;
    & .base{
      line-height: 20px;
      margin-bottom: 3px;
      & .default{
        padding: 2px 4px;
        background: #F66355;
        border-radius: 5px;
        font-size: 12px;
        color: #FFFFFF;
      }
      & .name{
        padding: 2px 4px;
        font-size: 15px;
        font-weight: bold;
        color: #000000;
      }
      & .mobile{
        padding: 2px 0px;
        font-size: 15px;
        color: #666666;
      }
    }
    & .address{
      line-height: 20px;
      font-size: 15px;
      font-weight: bold;
      color: #000000;
    }
  }
  &__edit{
    width: 20px;
    height: 20px;
  }
  &__bottom{
    width: 100%;
    height: 106px;
    position: fixed;
    bottom: 0;
    left: 0;
    background: #FFFFFF;
    box-shadow: 0px -6px 14px 0px rgba(0, 0, 0, 0.05);
    display: flex;
    align-items: center;
  }
  &__add_button{
    width: 311px;
    height: 46px;
    line-height: 46px;
    background: #222222;
    border-radius: 23px;
    font-size: 15px;
    color: #FFFFFF;
    text-align: center;
    margin: 0 auto;
  }
  &__close{
    width: 26px;
    height: 26px;
    position: absolute;
    right: 12px;
    top: 12px;
  }
  &__empty {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    >img {
      width: 168px;
      height: 168px;
    }
    >span {
      display: block;
      margin-top: 6px;
      max-width: 262px;
      font-size: 15px;
      line-height: 20px;
      font-weight: normal;
      color: #999999;
      text-align: center;
    }
  }
}
</style>